<template>
  <img
    :src="src"
    :alt="alt"
    height="40"
    style="height: 40px; width: auto; max-width: 175px; object-fit: contain; display: block;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo',
  props: {
    src: {
      type: String,
      required: false,
      default: '/logo.svg'
    },
    alt: {
      type: String,
      required: false,
      default: 'Logo'
    }
  }
}
</script>
